import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
//import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js'
import 'font-awesome/css/font-awesome.min.css';


import './assets/css/font-sans.css';
import './assets/css/icons.min.css';
import './assets/css/styles.min.css';
import './assets/css/loan-import.css';

import './assets/js/custom.js';


// import '@fortawesome/fontawesome-free/css/all.min.css';
// import JqueryMin from './assets/libs/jquery/jquery-3.7.1.js';


// Create root
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the app
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
